import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';
import { WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID } from '../../../webcomponents.constants';
import { FINDING_TYPE_TO_ICON_MAP, FindingClassType, RelatedFinding } from '../../types';
import { EasmAssetsInventoryGridWebComponent } from '../component/EasmAssetsInventoryGridWebComponent';

export class EasmAssetsInventoryRelatedAssetsProvider {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(
    page: number,
    limit: number,
    searchString: string = '',
    filters: Array<any> = []
  ): Promise<Array<any>> {
    const result = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'getAvailableRelatedFindings',
      payload: {
        findingClass: FindingClassType.ASSET,
        page,
        limit,
        relatedAssetString: searchString,
        companyId: filters[0],
      },
    });

    return result.data;
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response: Array<RelatedFinding>): ComplexSuggestedItem[] {
    return response.map((item: RelatedFinding) => {
      return {
        label: item.name,
        value: item.name,
        type: item.type,
      };
    });
  }

  static getExtraFilters(): Array<any> {
    const grid = document.querySelector(
      WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID
    ) as EasmAssetsInventoryGridWebComponent;

    if (!grid) {
      return [];
    }
    return [grid.getCompanyIdFilterValue()];
  }

  static getTypeToIconMapping(): Map<number, string> {
    return FINDING_TYPE_TO_ICON_MAP;
  }
}
